import React, {useEffect} from 'react'
import {PageHeader} from "../../../components/common/pageHeader/PageHeader";
import {NewsCard} from "../../../components/common/newsCard/NewsCard";
import {Pagination} from "../../../components/common/pagination/Pagination";
import {useNavigate, useSearchParams} from "react-router-dom";
import {URL_NEWS_CREATE} from "../../../mock/page_urls";
import {useQuery} from "react-query";
import {getNews} from "../../../services/newsSvc";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {EmptySection} from "../../../components/sections/empty/Empty";
import {separateFormatter} from "../../../utils/separateFormatter";
import {KTIcon, useDebounce} from "../../../../_metronic/helpers";

export const NewsPage = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)
  const searchQuery = searchParams.get("search") || ""

  const debouncedSearch = useDebounce(searchQuery, 500);

  const {
    data: newsData,
    isLoading: newsIsLoading,
    refetch: refetchNews
  } = useQuery(["getNews", page, debouncedSearch], () => getNews({
    params: {
      page_size: 8,
      page,
      search: debouncedSearch
    }
  }), {
    keepPreviousData: true,
  })

  const pageDetails = {
    title: "Yangiliklar",
    desc: `Jami yangiliklar soni: (${separateFormatter(newsData?.total_items || 0, " ", "ta")})`,
    buttons: [{
      onClick: () => navigate(URL_NEWS_CREATE),
      text: "Qo'shish",
      icon: "plus-square",
    }]
  };

  const totalItems = newsData?.total_items || 0;
  const itemsPerPage = newsData?.page_size || 8;

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchParams({page: "1", search: query});
  }

  useEffect(() => {
    if (debouncedSearch) {
      refetchNews();
    }
  }, [debouncedSearch, refetchNews]);


  return (
      <div>
        <div className="">
          <PageHeader pageDetails={pageDetails}/>
          <div className={"d-flex flex-wrap justify-content-between align-items-center rounded py-1 mb-5"}>
            <div className={"w-100 w-100 w-md-250px"}>
              <div className="d-flex align-items-center position-relative my-1">
                <KTIcon iconName={"magnifier"} className={"fs-1 position-absolute ms-3"}/>

                <input type="text" data-kt-user-table-filter="search"
                       className="form-control w-100 w-md-250px ps-12"
                       placeholder="Qidiruv..." value={searchQuery}
                       onChange={handleSearchChange}/>
              </div>
            </div>
          </div>

          {newsIsLoading ? (
              <LoaderSection height={"50vh"}/>
          ) : !newsData || newsData.data.length === 0 ? (
              <EmptySection height={"50vh"}/>
          ) : (
              <>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 g-6 mb-10">
                  {newsData.data.map((newsItem) => (
                      <NewsCard key={newsItem.id} refetchNews={refetchNews} newsItem={newsItem}/>
                  ))}
                </div>
                <Pagination
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                />
              </>
          )}
        </div>
      </div>
  )
}

